// extracted by mini-css-extract-plugin
export default {"container":"claimCommunicatorForm_container__7RLi8"};